import { render, staticRenderFns } from "./AddChildModal.vue?vue&type=template&id=14765f44"
import script from "./AddChildModal.vue?vue&type=script&lang=js"
export * from "./AddChildModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports